import { AuroraField } from "@/components/visuals/AuroraField";

export function PageHeader({
  title,
  subtitle,
}: {
  title: string;
  subtitle?: string;
}) {
  return (
    <header className="relative overflow-hidden border-b border-white/8">
      <AuroraField variant="soft" />
      <div className="container-page relative py-20 text-center md:py-28">
        <h1 className="text-display mx-auto max-w-3xl text-4xl leading-tight font-semibold md:text-5xl">
          {title}
        </h1>
        {subtitle ? (
          <p className="mx-auto mt-5 max-w-2xl text-base text-cream-100/60 md:text-lg">
            {subtitle}
          </p>
        ) : null}
      </div>
    </header>
  );
}
